import { useEffect, useState } from "react";
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import {
  API,
  get,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../../config";
import { formatMobile, formatName, formatPhone } from "../../../lib/Misc";
import Spin from "../../../components/Spin";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import { CardTitle } from "../../../components/ui/card";
import { CaretDownIcon, CaretRightIcon } from "@radix-ui/react-icons";
import ExpandOrgSubscription from "./ExpandOrgSubscription";

const RegisteredUserDetail = ({ userId, showView, setShowView, setUserId }) => {
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const { data } = await get(
          `${API.GET_REGISTERED_USER_FOR_ADMIN}/${userId}`
        );
        setDetail(data?.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }
    fetchData();
  }, [userId]);

  const columns = [
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "name",
      text: "Name",
      style: {
        width: "50%",
      },
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "email",
      text: "Email",
      style: {
        width: "50%",
      },
    },
  ];

  const organizationGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: detail?.organization[i]?.id,
        id: detail?.organization[i]?.id ? detail?.organization[i]?.id : "",
        name: detail?.organization[i]?.business_name
          ? detail?.organization[i]?.business_name
          : "-",
        email: detail?.organization[i]?.email,
        subscription: detail?.organization[i]?.subscription,
      });
    }
    return items;
  };

  const organizationUsers = organizationGenerator(detail?.organization?.length);

  const expandRow = {
    renderer: (row) => (
      <>
        <ExpandOrgSubscription expandList={true} id={row?.id} />
      </>
    ),
    onlyOneExpanding: true,
    showExpandColumn: true,
    expandByColumnOnly: true,
    headerClasses: THClasses,
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <CaretDownIcon />;
      }
      return <CaretRightIcon />;
    },
    className: TDClasses,
    expandHeaderColumnRenderer: () => {
      return <></>;
    },
  };

  return (
    <ResponsiveDrawerForm
      description={""}
      title={"User Details"}
      handleOpen={() => {}}
      handleClose={() => {
        setUserId();
        setShowView(false);
      }}
      className={"md:w-[70vw]"}
      open={showView}
      buttonClassName={""}
      setOpen={setShowView}
      read={true}
    >
      {loading ? (
        <Spin expand={true}/>
      ) : (
        <>
          <div className="modal-content-details">
            <CardTitle className="text-md mb-2">User Details</CardTitle>
            <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
              <p>
                <strong>Name:</strong>{" "}
                {formatName(detail?.first_name, detail?.last_name)}
              </p>
              <p>
                <strong>Email:</strong> {detail?.email}
              </p>
              <p>
                <strong>Phone:</strong>{" "}
                {detail?.phone ? formatPhone(detail?.phone) : ""}
              </p>
              <p>
                <strong>Mobile:</strong>{" "}
                {detail?.mobile ? formatMobile(detail?.mobile) : ""}
              </p>
              <p>
                <strong>Role:</strong>{" "}
                {detail?.role?.name ? detail?.role?.name : ""}
              </p>
              <p>
                <strong>Registered Date:</strong>{" "}
                {detail?.created_at
                  ? moment(detail?.created_at, "DD-MM-YYYY HH:mm:SS").format(
                      "DD-MM-YYYY"
                    )
                  : ""}
              </p>
            </div>
          </div>
          {organizationUsers?.length > 0 && (
            <div className="modal-content mt-4">
              <CardTitle className="text-md mb-2">
                Organization Details
              </CardTitle>
              <div className="custom-table">
                <div className="table-body-class">
                  <BootstrapTable
                    columns={columns}
                    keyField="key"
                    remote
                    data={organizationUsers}
                    expandRow={expandRow}
                    rowClasses={TRClasses}
                    noDataIndication="No Data Found"
                    classes={TableClasses}
                    wrapperClasses={TableWrapClasses}
                  />
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </ResponsiveDrawerForm>
  );
};

export default RegisteredUserDetail;
